module.exports = __webpack_public_path__ + "static/media/internal_env_3_media_11.9e12d0d6.webp";